<template>
  <div class="install-desc-android">
    <a href="https://walkingcloset.network/closet" target="_blank"><img class="d-block w-100 mb-3" :src="require('@/assets/images/installDesc/android1.png')" /></a>
    <img class="d-block w-100 mb-3" :src="require('@/assets/images/installDesc/android2.png')"  />
    <img class="d-block w-100 mb-3" :src="require('@/assets/images/installDesc/android3.png')"  />
  </div>
</template>


<script>

export default {
  name: 'InstallDescAndroid',
  data() {
    return {
    };
  },
  props: {
    imgSrc: {
    },
  },
  components: {
  },
  computed: {
	},
  watch: {
  },
  mounted() {
	},
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.install-desc-android {
}
</style>
